import React from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { PageContainer } from '@ant-design/pro-layout';
import { useHistory, useParams } from 'react-router-dom';
import { message } from 'antd';
import fp from 'lodash/fp';
import ProjectHeader from '../../ProjectHeader';
import BudgetForm from '../components/BudgetForm';
import BudgetHeaderCotent from '../components/BudgetHeaderCotent';
import { UPDATE_BUDGET, GET_BUDGETS } from '../../../../gql/budgets';
import { useLoading } from '../../../../hooks';

const transformToInitialValues = (budget) => ({
  ...fp.pick(['id', 'approvedFunding', 'additionalFunding', 'remarks'])(budget),
  budgetCategory: fp.get('budgetCategory.id')(budget),
});

const EditBudget = () => {
  const { projectId, id } = useParams();
  const history = useHistory();
  const { data, loading } = useQuery(GET_BUDGETS, {
    variables: {
      ids: [id],
    },
  });
  const [updateBudget, { loading: updateLoading }] = useMutation(
    UPDATE_BUDGET,
    {
      refetchQueries: [
        {
          query: GET_BUDGETS,
          variables: {
            projectIds: [projectId],
          },
        },
      ],
      onCompleted: ({ updateBudget }) => {
        message.success(
          `Budget ${updateBudget.budgetCategory.name} successfully edited`
        );
        history.push(`/projects/${projectId}/budget-virement`);
      },
      onError: (error) => {
        console.log({ error });
      },
    }
  );
  useLoading(updateLoading);

  const onFinish = (values) => {
    const { approvedFunding, additionalFunding, remarks } = values;
    updateBudget({
      variables: {
        input: {
          id,
          projectId,
          approvedFunding,
          additionalFunding,
          remarks,
        },
      },
    });
  };
  const initialValues = !data ? {} : transformToInitialValues(data?.budgets[0]);

  return (
    <ProjectHeader>
      <PageContainer
        loading={loading}
        header={{ title: 'Edit Budget' }}
        ghost
        style={{ marginBottom: '32px' }}
        content={<BudgetHeaderCotent />}
      >
        <BudgetForm
          onFinish={onFinish}
          initialValues={initialValues}
          isEdit={true}
        />
      </PageContainer>
    </ProjectHeader>
  );
};

export default EditBudget;
